module.exports = __webpack_public_path__ + "img/gallery_tall.336504ea.jpg";